export default __webpack_public_path__ + "media/images/chefs-4-0704f945059d0534b989fb0dc06d5acb.png";